export default "__VITE_ASSET__51dd9f44__"